import React, { useState } from "react";
import { Box } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import { getPolicies } from "../Dashboard/Policies/Policies";
import ChatHeader from "./component/ChatHeader";

const NewCustomerDashboard: React.FC = () => {
  
  return (
    <Box
      sx={{
        p: { xs: 2, md: 3, lg: 2 },
        // maxWidth: 140,
        width: "100%",
        mx: "auto",
        height:'calc(100vh - 60px)'
      }}
    >
      <ChatHeader />
    </Box>
  );
};

export default NewCustomerDashboard;